import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag } from './feature-toggles.module'

const _state = {
  isLeaderboardVisible: false,
}

const MUTATION_TYPES = {
  TOGGLE_LEADERBOARD_VISIBILITY: 'TOGGLE_LEADERBOARD_VISIBILITY',
}

const UNLEASH_FLAG_REMOVE_LEADERBOARD_SLIDE = 'remove-leaderboard-slides'

const _getters = {
  canUseNewLeaderboard(_, __, ___, rootGetters) {
    return isFeatureEnabled(rootGetters, UNLEASH_FLAG_REMOVE_LEADERBOARD_SLIDE) &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, UNLEASH_FLAG_REMOVE_LEADERBOARD_SLIDE)
  },

  isLeaderboardVisible(state, getters) {
    if (!getters.canUseNewLeaderboard) return false
    return state.isLeaderboardVisible
  },

}

const actions = {
  // show/hide the leaderboard during the quiz
  subscribeLeaderboardVisibilityAction: async ({ getters, dispatch }, { presentation }) => {
    if (!getters.canUseNewLeaderboard) return
    dispatch('kvSync/subscribeKeyAction', {
      key: `/leaderboards/${presentation.id}`,
    }, { root: true })
  },

}

const mutations = {
  [MUTATION_TYPES.TOGGLE_LEADERBOARD_VISIBILITY](state, isVisible) {
    if (typeof isVisible !== 'boolean') {
      state.isLeaderboardVisible = !state.isLeaderboardVisible
      return
    }
    state.isLeaderboardVisible = isVisible
  },

}

const plugins = {
  updateLeaderboardVisibility: (store) => {
    store.subscribeAction((action) => {
      if (action.type === 'kvSync/updateKeyValueAction') {
        const { key, value } = action.payload
        if (key.includes('/leaderboards/')) {
          store.commit(`leaderboard/${MUTATION_TYPES.TOGGLE_LEADERBOARD_VISIBILITY}`, JSON.parse(value).isVisible)
        }
      }
    })
  },
}

const leaderboardModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
  plugins,
}

export default leaderboardModule
